import { render, staticRenderFns } from "./daily-goal.vue?vue&type=template&id=4dad6054&scoped=true&"
import script from "./daily-goal.vue?vue&type=script&lang=js&"
export * from "./daily-goal.vue?vue&type=script&lang=js&"
import style0 from "./daily-goal.vue?vue&type=style&index=0&id=4dad6054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dad6054",
  null
  
)

export default component.exports